<!-- NAVBAR START -->
<nav class="navbar navbar-expand-lg py-lg-3 navbar-dark">
    <div class="container">
      <!-- logo -->
      <a href="landing.html" class="navbar-brand mr-lg-5">
        <img
        src="../../../assets/images/logo-white.svg"
          alt=""
          class="logo-dark"
          height="30"
        />
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="mdi mdi-menu"></span>
      </button>

      <!-- menus -->
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <!-- left menu -->
        <ul class="navbar-nav mr-auto align-items-center">
            <li class="nav-item mx-lg-1">
              <a  class="nav-link "  [routerLink]="['/landing']" routerLinkActive="active" >Home</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">Features</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/pricing']" routerLinkActive="active">Pricing</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/faqs']" routerLinkActive="active">FAQs</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/partners']" routerLinkActive="active">Partners</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/contact']" routerLinkActive="active">Contact</a>
            </li>
          </ul>
  
          <!-- right menu -->
          <ul class="navbar-nav ml-auto align-items-center">
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">Sign Up</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">Sign In</a>
            </li>
          </ul>
      </div>
    </div>
  </nav>
  <!-- NAVBAR END -->

  <!-- START HERO -->
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-12">
          <div class="text-center text-white">
            <h1 class="mt-0">
              <span class="mdi mdi-frequently-asked-questions"></span>
            </h1>
            <h3>
              Frequently Asked Questions
            </h3>
            <p class="mt-2">
              Here are some of the basic types of questions for our customers.
              For more <br />information please contact us.
            </p>

            <button type="button" class="btn btn-success btn-sm mt-2">
              <span class="mdi mdi-email-outline mr-1"></span> Email us your
              question
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END HERO -->

  <!-- START FAQ -->
  <section class="py-5">
    <div class="container">
      <div class="row mt-5">
        <div class="col-lg-5 offset-lg-1">
          <!-- Question/Answer -->
          <div>
            <div class="faq-question-q-box">Q.</div>
            <h4 class="faq-question text-body">
              Can I use this template for my client?
            </h4>
            <p class="faq-answer mb-4 pb-1 text-muted">
              Yup, the marketplace license allows you to use this theme in any
              end products. For more information on licenses, please refere
              <a
                href="https://themes.getbootstrap.com/licenses/"
                target="_blank"
                >here</a
              >.
            </p>
          </div>

          <!-- Question/Answer -->
          <div>
            <div class="faq-question-q-box">Q.</div>
            <h4 class="faq-question text-body">
              How do I get help with the theme?
            </h4>
            <p class="faq-answer mb-4 pb-1 text-muted">
              Use our dedicated support email (support&#64;coderthemes.com) to
              send your issues or feedback. We are here to help anytime.
            </p>
          </div>
        </div>
        <!--/col-lg-5 -->

        <div class="col-lg-5">
          <!-- Question/Answer -->
          <div>
            <div class="faq-question-q-box">Q.</div>
            <h4 class="faq-question text-body">
              Can this theme work with Wordpress?
            </h4>
            <p class="faq-answer mb-4 pb-1 text-muted">
              No. This is a HTML template. It won't directly with wordpress,
              though you can convert this into wordpress compatible theme.
            </p>
          </div>

          <!-- Question/Answer -->
          <div>
            <div class="faq-question-q-box">Q.</div>
            <h4 class="faq-question text-body">
              Will you regularly give updates of Hyper?
            </h4>
            <p class="faq-answer mb-4 pb-1 text-muted">
              Yes, We will update the Hyper regularly. All the future updates
              would be available without any cost.
            </p>
          </div>
        </div>
        <!--/col-lg-5-->
      </div>
      <!-- end row -->
    </div>
    <!-- end container-->
  </section>
  <!-- END FAQ -->

  <!-- START FOOTER -->
  <footer class="bg-dark py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <img
          src="../../../assets/images/logo-white.svg"
            alt=""
            class="logo-dark"
            height="30"
          />
          <p class="text-white-50 mt-4">
            Hyper makes it easier to build better websites with <br />
            great speed. Save hundreds of hours of design <br />
            and development by using it.
          </p>

          <ul class="social-list list-inline mt-3">
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-primary text-primary"
                ><span class="mdi mdi-facebook"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-danger text-danger"
                ><span class="mdi mdi-google"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-info text-info"
                ><span class="mdi mdi-twitter"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-secondary text-secondary"
                ><span class="mdi mdi-github-circle"></span
              ></a>
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Company</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >About Us</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Documentation</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50">Blog</a>
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Affiliate Program</a
              >
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Apps</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Ecommerce Pages</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50">Email</a>
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Social Feed</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Projects</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Tasks Management</a
              >
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Discover</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Help Center</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Our Products</a
              >
            </li>
            <li class="mt-2">
              <a href="privacy.html" class="text-white-50">Privacy</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="mt-5">
            <p class="text-white-50 mt-4 text-center mb-0">
              © 2018 - 2020 Hyper. Design and coded by Coderthemes
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- END FOOTER -->